module.exports = __webpack_public_path__ + "static/media/plus-hex.29a6e1b5.svg";